import * as logo from 'logo';

export interface ParseResult {
    error: string;
    instructions: any[];
}

export class LogoInterpreter {
    public static parse(script: string): ParseResult {
        let error = "";
        let instructions: any[] = [];

        logo.convert(script, function (err: string, obj: any) {
            if (err) {
                console.error("Couldn't parse Logo script.", script, arguments);
                error = err;
                return;
            }

            instructions = JSON.parse(JSON.stringify(obj));
        });

        return { error: error, instructions: instructions } as ParseResult;
    }
}

export default LogoInterpreter;
